const ConsentformHe = {
  pageTitle: "מחקר כוויות ילדים",
  language: "עברית",
  organization: "BGU",
  formTitle: "טופס הסכמה",

  parentSection: {
    greeting: "הורה יקר/ה,",
    paragraphs: [
      "מטרת המחקר הנוכחי היא להעמיק את הידע בנוגע לכוויות של ילדים מגיל שלושה חודשים עד 18 שנים.",
      "השתתפותך מוערכת וחשובה לנו מאוד.",
     "המחקר הוא מחקר משותף של אוניברסיטת בן גוריון בנגב והמרכז הרפואי סורוקה.\nההשתתפות כוללת מענה לשבע שאלות בלבד, צילום של הכוויה הוא התנדבותי לחלוטין ועורך כחמש דקות בלבד.", 
      "תוכל לדלג על כל שאלה שתרצה.",
      "איננו מבקשים שום מידע אישי, כגון שמך או כתובתך.",
      "בפרסומים מדעיים הקשורים למחקר לא יופיעו כל פרט מזהה שלך או של ילדך.",
      "ההשתתפות במחקר לא מעמידה אותך ואת ילדך בכל סיכון שהוא או מספקת הטבה כלשהי.",
      "אם יש לך שאלות כלשהן בנוגע למחקר זה, אנא צור/צרי איתנו קשר באמצעות הפרטים המופיעים מטה.",
      "השאלון מנוסח בלשון זכר מטעמי נוחות בלבד אך מיועד לכל מגדר.",
      "אנו מאחלים לילדך רפואה שלמה! תודה על הזמן שאת/ה מקדיש/ה להשתתפות במחקר זה."
    ],
    closing: "בברכה,",
    team: "צוות המחקר",
    contactText: "ליצירת קשר אנא כתבו ל־",
    email: "taliamst@bgu.ac.il",
    phoneText: "או בטלפון",
    phone: "0545655164"
  },

  doctorSection: {
    title: "רופא.ה",
    declaration: [
      "בחתימתי אני מצהיר כי הסברתי להורה הקטין בעל פה על המחקר בהתאם לכתוב בטופס זה.",
      "אני סבור שההורה הבין את הנאמר, היה לו מספיק זמן לקרוא את הטופס וההורה הביע את הסכמתו להשתתף במחקר.\nבנוסף, אני מצהיר כי הסברתי לקטין בנוכחות הוריו על המחקר והוא הביע את רצונו להשתתף בסקר."
    ],
    doctorNameLabel: "שם הרופא.ה",
    doctorName: "ד״ר ישראלי ישראלי",
    HospitalName: "שם בית חולים",
    clickToSign: "לחץ לחתימה",
    signature: "חתימה",
    licenseNumberLabel: "מספר רישיון",
    licenseNumber: "1685723",
    dateLabel: "תאריך",
    date: "02/03/2024"
  },

  signature: {
  clickToSign: "לחתימה יש ללחוץ כאן",
  title: "חתימה",
  instruction: "יש לחתום בתוך המשבצת המסומנת",
  save: "שמור",
  clear: "נקה חתימה",
  previewAlt: "תצוגה מקדימה של החתימה"
},

  parentApprovalSection: {
    fullNameLabel: "שם מלא",
    parentNameLabel: "שם ההורה",
    serialNumberLabel: "מס׳ סידורי",
    serialNumber: "12-986-45",
    approvalLabel: "אישור"
  },
  error: {
  required:"*שדה זה הוא שדה חובה",
  require2:"*יש למלא שם פרטי ושם משפחה",
    doctorName: "אנא הזן את שם הרופא.ה",
    licenseNumber: "אנא הזן את מספר הרישיון",
    HospitalName: "אנא הזן את שם בית החולים"
  }
};

export default ConsentformHe;
